<style>
.layout.row {
  margin-bottom: 20px !important;
}
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float: left;">Ответы на вопрос "{{ question ? question.name : '' }}"</h3>
          <v-btn color="pink" dark small fab @click="openEditingModal()">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down" />
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table :headers="headers" :search="search" :items="items" :rows-per-page-items="[10, 25]"
                class="elevation-1" item-key="id" no-results-text="Нет результатов" rows-per-page-text="На странице"
                v-model="selectedItems">
                <template slot="items" slot-scope="props">
                  <tr :class="props.item.isActive ? null : 'red lighten-4'">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.value }}</td>
                    <td>{{ props.item.orderKey }}</td>
                    <td>
                      <v-btn depressed outline icon fab dark color="primary" small
                        @click="openEditingModal(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>

                      <v-btn depressed outline icon fab dark color="pink" small @click="openRemovingModal(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">
                <v-dialog v-model="editingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        {{ editedIndex === -1 ? 'Добавление' : 'Редактирование' }}
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="isEditing">
                          <v-flex xs4>
                            <v-subheader>ID</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="ID" v-model="modalData.id" readonly />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Наименование</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Наименование" v-model="modalData.value" :rules="rules.required"
                              required />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Ключ сортировки</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field label="Ключ сортировки" v-model="modalData.orderKey" type="number" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Вносить свой вариант</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isOther" />
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Статус</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-switch v-model="modalData.isActive" />
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn flat @click="closeEditingModal()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="removingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить запись?</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="closeRemovingModal()">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="remove(modalData)">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      questionId: +this.$route.params.id,
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Наименование',
          value: 'value',
        },
        {
          text: 'Ключ сортировки',
          value: 'orderKey',
        },
        {
          text: 'Действия',
          value: '',
        }
      ],
      search: '',
      selectedItems: [],
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      isEditing: true,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
      },
      editingModalOpened: false,
      removingModalOpened: false,
    };
  },

  mounted: function () {
    this.refresh();

    if (!this.question) {
      this.$store.dispatch('pollQuests/getPollQuestsData');
    }
  },

  destroyed: function () {
    this.$store.commit('questionAnswers/setItemsByQuestion', { items: [] });
  },

  computed: {
    items() {
      return this.$store.getters['questionAnswers/itemsByQuestion'];
    },

    question() {
      return this.$store.getters['pollQuests/pollQuestsData'].find(q => q.Id === this.questionId);
    },
  },

  methods: {
    refresh() {
      this.$store.dispatch('questionAnswers/loadItemsByQuestion', { questionId: this.questionId });
    },

    loadModalData(item) {
      if (!item) {
        this.modalData = {
          id: -1,
          pollQuestsId: this.questionId,
          value: '',
          orderKey: 10,
          isOther: false,
          isActive: true,
        };
        this.oldModalData = {};
        this.editedIndex = -1;
        this.isEditing = false;
      } else {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.items.indexOf(item);
        this.isEditing = true;
      }
    },

    openEditingModal(item) {
      this.loadModalData(item);
      this.editingModalOpened = true;
    },

    closeEditingModal() {
      if (this.editedIndex !== -1) {
        Object.assign(this.items[this.editedIndex], this.oldModalData);
      }

      this.editingModalOpened = false;
    },

    closeRemovingModal() {
      this.removingModalOpened = false;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch('questionAnswers/save', { index: this.editedIndex, data: this.modalData });
        this.refresh();
        this.editingModalOpened = false;
      }
    },

    openRemovingModal(data) {
      this.modalData = data;
      this.removingModalOpened = true;
    },

    async remove(item) {
      await this.$store.dispatch('questionAnswers/remove', { item });
      this.refresh();
      this.closeRemovingModal();
    },
  }
};

</script>


// WEBPACK FOOTER //
// src/pages/ui/QuestionAnswers.vue